/**
 * Проверяет что obj -- это Buffer, да так что можно использовать в браузере и не развалистся
 * Скопипастил с https://github.com/feross/is-buffer ибо тайпинг там неписал без type guard-а
 * @param obj
 */
export function isBuffer(obj: unknown): obj is Buffer {
    return (
        typeof obj === "object" &&
        obj != undefined &&
        obj.constructor != undefined &&
        // @ts-ignore
        typeof obj.constructor["isBuffer"] === "function" &&
        // @ts-ignore
        Boolean(obj.constructor["isBuffer"](obj))
    );
}
